<template>
  <router-view />
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class Home extends Vue {
}
</script>

<style>
html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: 'Hind', "Helvetica Neue",Helvetica;
}

*, *::before, *::after {
  outline: 0 !important;
  box-sizing: border-box !important;
}

#shareAPIPolyfill-backdrop,
#shareAPIPolyfill-container {
  z-index: 100000 !important;
}
</style>
